module.exports = __webpack_public_path__ + "static/media/bridges-ex.20563b56.png";